import { render, staticRenderFns } from "./TaskRunTable.vue?vue&type=template&id=5f8b748a&scoped=true"
import script from "./TaskRunTable.vue?vue&type=script&lang=js"
export * from "./TaskRunTable.vue?vue&type=script&lang=js"
import style0 from "./TaskRunTable.vue?vue&type=style&index=0&id=5f8b748a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b748a",
  null
  
)

export default component.exports